import React from 'react';
import Header from '../Layout/Header';
import './css/parking-allot.css';
import axios from 'axios';
import { useContext, useEffect, useRef, useState } from 'react';
import { Layout } from 'antd';
import Sidebar from '../Layout/Sidebar';
import { dataUser, dataLocation } from './..//Helpers/util';
import { toast } from 'react-toastify';
import { CSVLink } from 'react-csv';
import ParkingReqFilterNew from './parkingReqFilterNew';
import ParkingReqSortNew from './parkingReqSortNew';
import MarketingPanel from '../MarketingPanel';
import { getServiceAccess } from '../../Redux/action/userActions';
import axiosInstance from '../../utils/axiosInstance';
import mixpanel from 'mixpanel-browser';
import ParkingViewNew from './ParkingViewNew';
import { MultiSelect } from 'react-multi-select-component';
import Select from 'react-select';
import moment from 'moment';
import { Navigate, useNavigate } from 'react-router-dom';

import ViewGuideicon from './img/parking-allotment/view-guide-icon.svg';
import CustomHeader from '../Layout/Header';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import SwInput from '../Common/FormComponent/SwInput';
import SwKpiGroup from '../Common/SwKPI/SwKpiGroup';
import SwKpi from '../Common/SwKPI/SwKPI';
import SwButton from '../Common/SwButtons/SwButtons';
import SwModal from '../Common/SwModal/SwModal';
import AntDTable from '../Common/AntDTable/AntDTable';
import SwNoData from '../Common/NoData/NoData';
import SwLoader from '../Common/SwLoader/SwLoader';

const apiURL = require('./../../constant');
const URL_API = apiURL.PROD_URL;
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();

var LocationObj = JSON.parse(userDataLocal1);
let article = {
  company_id: UserObj ? UserObj.company_id : 202,
  offset: 0,
  limit: 25,
  search: '',
  location_id: [],
};
let articleCopy = article;

export default function ParkPlus() {
  const [parkingProviders, setParkingProviders] = useState([]);
  const [availableLocations, setAvailableLocations] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [ParkingUser, setParkingUser] = useState([]);
  const [ParkingCount, setParkingCount] = useState([]);
  const [RequestId, setRequestId] = useState(0);
  const [RequestText, setRequestText] = useState('');
  const [RequestStatus, setRequestStatus] = useState('');
  const [TagId, setTagId] = useState('');
  const [VehicleNumber, setVehicleNumber] = useState('');
  const [FilterData, setFilterData] = useState({});
  const [SortData, setSortData] = useState('');
  const [Row, setRowData] = useState('25');
  const [PageNo, setPageNoData] = useState(1);
  const [bg, changeBGColor] = useState(0);
  const [accessServiceLists, setAccessServiceLists] = useState([]);
  const [loaderServiceAccess, setLoaderServiceAccess] = useState(true);
  const [rowDatas, setRowDatas] = useState(null);
  const [location, setLocation] = useState([{ value: '', label: 'Select' }]);
  const [selectedLocations, setSelectedLocations] = useState(
    sessionStorage.getItem('selectedLocations')
      ? JSON.parse(sessionStorage.getItem('selectedLocations'))
      : [],
  );
  const [selectedLocation, setSelectedLocation] = useState(
    sessionStorage.getItem('selectedLocation')
      ? JSON.parse(sessionStorage.getItem('selectedLocation'))
      : null,
  );
  const [selectedLocationIds, setSelectedLocationIds] = useState([]);

  const [ssoLoginUrl, setSsoLoginUrl] = useState('');
  const [alertMsg, setAlertMsg] = useState('');
  const [issueTagLogin, setIssueTagLogin] = useState('');
  const [shouldNavigate, setShouldNavigate] = useState(false);
  const [navigateTo, setNavigateTo] = useState('');
  const [isAccessDeniedOpen, setIsAccessDeniedOpen] = useState(false);
  const [isActionModalOpen, setIsActionModalOpen] = useState(false);
const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const navigate = useNavigate();

  const headers = [
    { label: 'Id', key: 'rec_id' },
    { label: 'Email', key: 'email' },
    { label: 'Phone', key: 'phone' },
    { label: 'Status', key: 'status' },
    { label: 'User Id', key: 'user_id' },
    { label: 'User Name', key: 'user_name' },
    { label: 'Vehicle Number', key: 'vehicle_number' },
    { label: 'Vehicle RC', key: 'vehicle_rc' },
    { label: 'Vehicle Wheelers', key: 'wheeler' },
  ];

  useEffect(() => {
    const fetchParkingCount = async () => {
      try {
        // Get the authentication token from localStorage
        const authToken = JSON.parse(localStorage.getItem('headData'));

        // Make the API request using axios with async/await
        if (article.location_id.length) {
          const response = await axiosInstance.post(
            `${
              process.env.REACT_APP_API_GATEWAYS_URL
            }cspoc/api/v1/parking/parkplus_countv2`,
            article,
            {
              headers: {
                Authorization: authToken?.spintlyToken, // Add the token in the Authorization header
              },
            },
          );
  
          // Set the parking count data after receiving the response
          setParkingCount(response.data.data);
        }
        
      } catch (error) {
        // Handle any error that might occur during the API call
        console.error('Error fetching parkplus count:', error);
      }
    };

    // Call the async function
    fetchParkingCount();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Change the list status first
        changeListStatus(9);

        // if(type > 0 && type < 8)
        // {
        // 	article.status=type;
        // }
        // Send the async request to fetch parking data
        const response = await axiosInstance.post(
          `${
            process.env.REACT_APP_API_GATEWAYS_URL
          }cspoc/api/v1/parking/parking_requestv2`,
          article,
        );

        // Set the parking data from the response
        setParkingUser(response.data.data);

        // Call setData() after the request
        setData();
      } catch (error) {
        // Handle any errors
        console.error('Error fetching parking request data:', error);
      }
    };

    // Call the async function inside the useEffect
    fetchData();
  }, []); // Empty dependency array to run the effect only once when the component mounts

  const parkingView = () => {
    mixpanel.track('Parking View', {
      PageName: 'Parking',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Parking',
    });
  };

  // Popup Modal
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // useEffect(() => {
  //   const visitedBefore = localStorage.getItem('visitedBefore');

  //   // If user hasn't visited before, show the popup with a 3-second delay
  //   if (!visitedBefore) {
  //     const timer = setTimeout(() => {
  //       openModal();

  //       // Set flag in localStorage to indicate user has visited
  //       localStorage.setItem('visitedBefore', true);
  //     }, 3000);

  //     return () => {
  //       clearTimeout(timer); // Clear the timer if the component is unmounted before the 3 seconds
  //     };
  //   }
  // }, []);

  // Popup Modal Ends

  const changeListStatus = async type => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      // Change background color based on status type
      changeBGColor(type);

      // Update the article status
      if (type > 0 && type < 8) {
        article.status = type;
      } else {
        article.status = false;
      }

      // Set the location_id based on selected locations
      article.location_id = selectedLocations?.map(item =>
        item.value.toString(),
      );

      // Await the POST request for parking request
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parking_requestv2`,
        article,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      );

      // Set the parking user data once the request is successful
      setParkingUser(response.data.data);

      // Optionally call setData() here if needed
      // setData();
    } catch (error) {
      // Log any errors
      console.error(
        'Error changing list status:',
        error.response?.body || error,
      );
    }
  };

  const filterListing = async e => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      if (e.key === 'Enter') {
        // Prepare the article with search and other filters
        article.search = e.target.value;
        article.offset = 0;
        article.limit = 25;
        article.location_id = selectedLocations?.map(item =>
          item.value.toString(),
        );

        // Await the axios requests instead of using .then()
        const parkingUserResponse = await axiosInstance.post(
          `${
            process.env.REACT_APP_API_GATEWAYS_URL
          }cspoc/api/v1/parking/parking_requestv2`,
          article,
          {
            headers: {
              Authorization: authToken?.spintlyToken,
            },
          },
        );
        // Set the parking user data
        setParkingUser(parkingUserResponse.data.data);

        // Await the second axios request for parkplus count
        const parkingCountResponse = await axiosInstance.post(
          `${
            process.env.REACT_APP_API_GATEWAYS_URL
          }cspoc/api/v1/parking/parkplus_countv2`,
          article,
          {
            headers: {
              Authorization: authToken?.spintlyToken,
            },
          },
        );
        // Set the parking count data
        setParkingCount(parkingCountResponse.data.data);

        // Call setData() function after the requests
        setData();
      }
    } catch (error) {
      // Log any error that occurs during the API calls
      console.error(
        'Error fetching data:',
        error.response ? error.response.body : error,
      );
    }
  };

  const fillStatus = async (id, status, tag_id, vehicle_number) => {
    let alertText = 'Are you sure you want to approve this request ?';
    if (status == 6) {
      alertText = 'Are you sure you want to reject this request ?';
    } else if (status == 5) {
      alertText = 'Are you sure you want to delete this request ?';
    }
    setRequestId(id);
    setRequestText(alertText);
    setRequestStatus(status);
    setTagId(tag_id);
    setVehicleNumber(vehicle_number);
  };

  const changeStatus = async (id, status, tag_id) => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      // Prepare the data to be sent in the POST request
      let dataAry = {
        rec_id: id,
        status: status,
        spoc_name: `${UserObj.fname} ${UserObj.lname}`,
        comp_name: UserObj.company_name,
        tag_id: tag_id,
      };

      // First POST request: change the status
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parkplus_statusv2`,
        dataAry,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      );

      // If the response status is 200, handle the result
      if (response.status === 200) {
        if (status === 2) {
          toast.success('Request Approved Successfully', {});
        } else if (status === 6) {
          toast.info('Request Rejected Successfully', {});
        } else {
          toast.warn('Request Deleted Successfully', {});
        }

        // Update article status and make the second API call for count
        let articleStatus = article.status;
        article.status = false;

        const countResponse = await axiosInstance.post(
          `${
            process.env.REACT_APP_API_GATEWAYS_URL
          }cspoc/api/v1/parking/parkplus_countv2`,
          article,
          {
            headers: {
              Authorization: authToken?.spintlyToken,
            },
          },
        );

        setParkingCount(countResponse.data.data);

        // Change list status if needed
        changeListStatus(articleStatus);
      }
    } catch (error) {
      // Log any error that occurs
      console.error('Error changing status:', error.response?.body || error);
    }
  };

  const changeDeleteStatus = async (id, vehicle_number) => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      // Prepare the data for the DELETE request
      let dataAry = {
        rec_id: id,
        vehicle_number: vehicle_number,
      };

      // First POST request to delete the request
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parkplus_delete`,
        dataAry,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      );

      // Check if the response status is 200 (success)
      if (response.data.status === 200) {
        toast.error('Request Deleted Successfully', {});

        // Save the current article status and reset it
        let articleStatus = article.status;
        article.status = false;

        // Second POST request to update the parking count
        const countResponse = await axiosInstance.post(
          `${
            process.env.REACT_APP_API_GATEWAYS_URL
          }cspoc/api/v1/parking/parkplus_countv2`,
          article,
          {
            headers: {
              Authorization: authToken?.spintlyToken,
            },
          },
        );

        // Set the updated parking count
        setParkingCount(countResponse.data.data);

        // Change the list status if needed
        changeListStatus(articleStatus);
      } else {
        toast.error(response.data.message, {});
      }
    } catch (error) {
      // Log any error that occurs
      console.error('Error deleting status:', error.response?.body || error);
    }
  };

  const changeListNum = async num => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      // Set the limit and location_id for the request
      article.limit = num;
      article.location_id = selectedLocations?.map(item =>
        item.value.toString(),
      );

      // Await the API request to get parking request data
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parking_requestv2`,
        article,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      );

      // Set the parking user data from the response
      setParkingUser(response.data.data);

      // Call setData() if necessary
      setData();
    } catch (error) {
      // Handle any error that occurs during the request
      console.error(
        'Error fetching parking request data:',
        error.response?.body || error,
      );
    }
  };

  const previousPage = async num => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      // Set the offset and location_id for the request
      article.offset = num;
      article.location_id = selectedLocations?.map(item =>
        item.value.toString(),
      );

      // Await the API request to get parking request data
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parking_requestv2`,
        article,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      );

      // Set the parking user data from the response
      setParkingUser(response.data.data);

      // Call setData() if necessary
      setData();
    } catch (error) {
      // Handle any error that occurs during the request
      console.error(
        'Error fetching parking request data:',
        error.response?.body || error,
      );
    }
  };
  const nextPage = async num => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      // Set the offset and location_id for the request
      article.offset = num;
      article.location_id = selectedLocations?.map(item =>
        item.value.toString(),
      );

      // Await the API request to get parking request data
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parking_requestv2`,
        article,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      );

      // Set the parking user data from the response
      setParkingUser(response.data.data);

      // Call setData() if necessary
      setData();
    } catch (error) {
      // Handle any error that occurs during the request
      console.error(
        'Error fetching parking request data:',
        error.response?.body || error,
      );
    }
  };

  let totalRec = ParkingCount.total;
  let ptype = [
    'total',
    'pending',
    'assigned',
    'approved',
    'deleted',
    'deleted_req',
    'rejected',
    'rejected_sw',
  ];
  if (article.status) {
    var typeVar = ptype[article.status];
    totalRec = ParkingCount[typeVar];
  }
  let count = parseInt(article.offset);
  //let totalRec = ParkingCount.total;

  let totalPage = Math.ceil(totalRec / article.limit);
  if (totalRec / article.limit > 0 && totalRec / article.limit < 1)
    totalPage = 1;
  let nextSet = parseInt(article.limit) + parseInt(count);
  let prevSet = count - article.limit;
  let pgno = parseInt(nextSet / article.limit);
  let lastPage = totalPage - pgno;
  let next = parseInt(totalRec - article.limit * pgno);
  let forward = 'Disabled';
  let backward = 'Disabled';

  async function setData() {
    count = parseInt(article.offset);
    totalRec = ParkingCount.total;
    totalPage = Math.ceil(totalRec / article.limit);
    if (totalRec / article.limit > 0 && totalRec / article.limit < 1)
      totalPage = 1;
    nextSet = parseInt(article.limit) + parseInt(count);
    prevSet = count - article.limit;
    pgno = parseInt(nextSet / article.limit);
    next = parseInt(totalRec - article.limit * pgno);
    lastPage = totalPage - pgno;
  }

  if (next > 0) {
    forward = '';
  }

  if (pgno > 1) {
    backward = '';
  }

  // const clearSearchBox = () => {
  // 	// this.setState({ searchText: "" });
  // }

  const handleLanguage = langValue => {
    setFilterData(langValue);
  };

  const shortSelectData = shortallkey => {
    setSortData(shortallkey);
  };

  useEffect(() => {
    fetchServiceAccess();
    parkingView();
  }, []);

  const fetchServiceAccess = async () => {
    const getCompanyId = UserObj.company_id;
    const response = await getServiceAccess(getCompanyId);
    setAccessServiceLists(response);
    setLoaderServiceAccess(false);
  };

  const childCallback = async value => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    // If value is null, reset the article to its original copy
    if (value == null) {
      article = articleCopy;
    } else {
      article = {
        ...article,
        ...value,
      };
    }

    try {
      // Set the location_id for the article
      article.location_id = selectedLocations?.map(item =>
        item.value.toString(),
      );

      // First API call for parking request
      const parkingResponse = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parking_requestv2`,
        article,
        {},
      );
      setParkingUser(parkingResponse.data.data);

      // Second API call for parkplus count
      const parkingCountResponse = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parkplus_countv2`,
        article,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      );
      setParkingCount(parkingCountResponse.data.data);
    } catch (e) {
      console.error('Error during API calls:', e);
    }
  };

  let serviceAccess = true;
  const serviceAccessId = 8;
  if (accessServiceLists.length > 0) {
    let serviceAccessobject = {};
    accessServiceLists.map(e => {
      if (e.id == serviceAccessId) serviceAccessobject = e;
    });
    serviceAccess = false;
    if (serviceAccessobject) serviceAccess = serviceAccessobject.service_access;
  }

  const handleRowClick = data => {
    setRowDatas(data);
  };

  /*Start Code for multiselect locations based on spoc */

  useEffect(() => {
    let authToken = JSON.parse(localStorage.getItem('headData'));
    const params = {
      params: { spoc: UserObj.rec_id, client: UserObj.company_id },
      headers: {
        Authorization: authToken?.spintlyToken,
      },
    };
    axios
      .get(
        `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
        params,
      )
      .then(res => {
        if (res.data.status == 'success') {
          setLocation(res.data.data);
        }
      })
      .catch(err => {
        console.log('err', err);
      });
  }, []);

  const LocationData = [];
  location.map(item =>
    LocationData.push({ value: item?.rec_id, label: item.location_name }),
  );

  useEffect(() => {
    let filter = {};
    if (selectedLocationIds?.length > 0) {
      filter.location = selectedLocationIds;
      if (selectedLocations.length > 0) {
        childCallback();
      }
    }
  }, [selectedLocationIds]);
  const fetchParkingProvider = async (locationId, articleData) => {
    try {
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/get_parking_provider`,
        { locationId },
      );

      if (response.data.status === 'success') {
        const provider = response.data.data;
        setParkingProviders(provider);

        if (provider == 'PARK_SMART') {
          setNavigateTo('/park-smart');
          setShouldNavigate(true);
        } else if (provider == 'PARK_PLUS') {
          await fetchParkingData(articleData); // pass correct article data
          setNavigateTo('/park-plus');
          setShouldNavigate(true);
        }
      } else {
        console.warn('No providers found');
      }
    } catch (error) {
      console.error('Error fetching parking provider:', error);
    }
  };

  const fetchParkingData = async articleData => {
    try {
      const authToken = JSON.parse(localStorage.getItem('headData'));

      const countResponse = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parkplus_countv2`,
        articleData,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      );
      setParkingCount(countResponse.data.data);

      const requestResponse = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parking_requestv2`,
        articleData,
      );
      setParkingUser(requestResponse.data.data);

      await setData();
    } catch (error) {
      console.error('Error fetching parking data:', error);
    }
  };

  function onLocationChange(location) {
    if (location) {
      const locationValue = location.value.toString();
      
      // Update state
      setSelectedLocation(location);
      setSelectedLocationIds([locationValue]);
      setSelectedLocations([location]);
      
      // Store in session storage
      sessionStorage.setItem('selectedLocation', JSON.stringify(location));
      sessionStorage.setItem('selectedLocationId', locationValue);
      
      // Update article synchronously
      const updatedArticle = { ...article, location_id: [locationValue] };
      
      // Pass updated article directly to provider & data functions
      fetchParkingProvider(locationValue, updatedArticle);
    } else {
      // Clear all states when location is deselected
      setSelectedLocation(null);
      setSelectedLocationIds([]);
      setSelectedLocations([]);
      sessionStorage.removeItem('selectedLocation');
      sessionStorage.removeItem('selectedLocationId');
      setParkingUser([]);
      setParkingCount([]);
      article.location_id = [];
    }
  }
  useEffect(() => {
    // Load saved parking data
    const savedParkingData = sessionStorage.getItem('parkingData');
    const savedLocation = sessionStorage.getItem('selectedLocation');
    const savedLocationId = sessionStorage.getItem('selectedLocationId');
    
    if (savedLocation && savedLocationId) {
      const parsedLocation = JSON.parse(savedLocation);
      
      // Restore location states
      setSelectedLocation(parsedLocation);
      setSelectedLocationIds([savedLocationId]);
      setSelectedLocations([parsedLocation]);
      
      // Update article with location
      article.location_id = [savedLocationId];
      
      // Fetch parking provider and data
      fetchParkingProvider(savedLocationId, article);
    }
  }, []);

  useEffect(() => {
    if (shouldNavigate && navigateTo) {
      navigate(navigateTo);
      setShouldNavigate(false);
    }
  }, [shouldNavigate, navigateTo]);

  useEffect(() => {
    if (location && location.length > 0) {
      const selectLocationData = location.map(item => ({
        value: item['rec_id'],
        label: item['location_name'],
      }));

      setAvailableLocations(selectLocationData); // A state for populating dropdown
    }
  }, [location]);

  /*End Code for multiselect locations based on spoc */

  const ssoParkPlusLogin1 = async () => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      let dataAry = {
        companyId: UserObj?.company_id,
      };

      // Use await instead of .then()
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parkplus_login`,
        dataAry,
        {},
      );

      // Check the response status and update the state accordingly
      if (response.data.status === 200) {
        setSsoLoginUrl(response.data.data);
      } else if (response.data.status === 400) {
        setAlertMsg(response.data.status);
      }
    } catch (error) {
      // Log the error in case of failure
      console.error('Error during the API call:', error);
    }
  };

  const ssoParkPlusLogin = async () => {
    try {
      let dataAry = {
        companyId: UserObj?.company_id,
      };

      // Use await instead of .then()
      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parkplus_bulk_assign`,
        dataAry,
        {},
      );

      // Check the response status and update the state accordingly
      if (response.data.status === 200) {
        setSsoLoginUrl(response.data.data);
      } else if (response.data.status === 400) {
        setAlertMsg(response.data.status);
      }
    } catch (error) {
      // Log the error in case of failure
      console.error('Error during the API call:', error);
    }
  };

  const openUrlInNewTab1 = () => {
    ssoParkPlusLogin1();
  };

  // Function to open URL in a new tab
  const openUrlInNewTab = () => {
    ssoParkPlusLogin();
  };

  useEffect(() => {
    if (ssoLoginUrl) {
      window.open(ssoLoginUrl, '_blank');
    }
  }, [ssoLoginUrl]);

  const issueTagButtonClick = async (
    vehicle_number,
    phone,
    wheeler,
    user_name,
    email,
  ) => {
    const params = {
      companyId: UserObj.company_id,
      vehicle_number,
      phone,
      wheeler,
      user_name,
      user_email: email,
    };

    try {
      // Await the response from the axios POST request
      const res = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v1/parking/parkplus_assign`,
        params,
        {},
      );

      // Handle the response based on the status
      if (res.data.status === 200) {
        setIssueTagLogin(res.data.data);
      } else if (res.data.status === 400) {
        toast.error(res.data.message, {});
      }
    } catch (error) {
      // Handle any errors that occur during the request
      console.error('Error during the API call:', error);
    }
  };

  useEffect(() => {
    if (issueTagLogin) {
      window.open(issueTagLogin, '_blank');
    }
  }, [issueTagLogin]);
  const toggleCollapsed = () => {
    setCollapsed(prevState => !prevState);
  };

  if (shouldNavigate && navigateTo) {
    return <Navigate to={navigateTo} replace />;
  }
  const columns = [
  {
    title: "Location",
    dataIndex: "location_name",
    key: "location_name",
  },
  {
    title: "Name",
    dataIndex: "user_name",
    key: "user_name",
  },
  {
    title: "Phone No.",
    dataIndex: "phone",
    key: "phone",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Vehicle Number",
    noWrap: true,
    dataIndex: "vehicle_number",
    key: "vehicle_number",
  },
  {
    title: "Vehicle RC",
    key: "vehicle_rc",
    noWrap: true,
    render: (_, record) => (
      <SwButton
        size="sm"
        variant="dark-outline"
        className="SwBadge"
        onClick={(e) => {
          e.stopPropagation();
          if (!record.vehicle_rc) {
            toast.warning("Vehicle RC is not available");
            return;
          }
          window.open(record.vehicle_rc, "_blank");
        }}
      >
        View
      </SwButton>
    ),
  },
  {
    title: "Vehicle Type",
    noWrap: true,
    dataIndex: "wheeler",
    key: "wheeler",
    render: (val) => `${val} Wheeler`,
  },
  {
    title: "Tag",
    dataIndex: "tag_id",
    key: "tag_id",
  },
  {
    title: "Request Date and Time",
    noWrap: true,
    dataIndex: "created_at",
    key: "created_at",
    render: (val) =>
      moment(val).utcOffset(0).format("YYYY-MM-DD HH:mm:ss"),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (val) => {
      if (val === "Pending") return <span className="SwLinkWarning">Pending</span>;
      if (val === "Approved") return <span className="SwLinkInfo">Whitelisted</span>;
      if (val === "Rejected") return <span className="SwLinkDanger">Rejected</span>;
      if (val === "Deleted") return <span className="SwLinkDanger">Deleted</span>;
      return null;
    },
  },
  {
    title: "Action",
    key: "action",
    render: (_, record) => {
      if (record.status === "Pending") {
        return (
          <div className="d-flex Parkplus_Table_CTA_Column">
            <SwButton
              size="sm"
              variant="dark"
              className="SwBadge me-2"
              onClick={(e) => {
                e.stopPropagation();
                issueTagButtonClick(
                  record.vehicle_number,
                  record.phone,
                  record.wheeler,
                  record.user_name,
                  record.email
                );
              }}
            >
              + Issue Tag
            </SwButton>

            <SwButton
              size="sm"
              variant="danger-outline"
              className="SwBadge"
              onClick={(e) => {
                e.stopPropagation();
                fillStatus(record.rec_id, 6, 0, 0);
                setIsActionModalOpen(true);
              }}
            >
              Reject
            </SwButton>
          </div>
        );
      }

      if (record.status === "Approved") {
        return (
          <SwButton
            size="sm"
            variant="danger"
            className="SwBadge"
            onClick={(e) => {
              e.stopPropagation();
              fillStatus(
                record.rec_id,
                5,
                record.tag_id,
                record.vehicle_number
              );
              setIsDeleteModalOpen(true);
            }}
          >
            Delete
          </SwButton>
        );
      }

      return null;
    },
  },
];

  return (
    <>
      <Layout>
        <Sidebar collapsed={collapsed} />
        <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />

        <Layout
          className={
            collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'
          }
        >
          <div
            className="custome modal right fade"
            id="parkingRequestModal"
            data-backdrop="static"
          >
            {' '}
            {rowDatas && (
              <ParkingViewNew
                rowDatas={rowDatas}
                article={article}
                changeListStatus={changeListStatus}
              />
            )}
          </div>{' '}
          {serviceAccess === true ? (
            <>
              <div class="shade" />
              <div class="PageContent">
                <div className="row">
                  <div class="col-md-4">
                    <div className="SwHeading">
                      <h2>
                        Parking Management
                      </h2>
                    </div>
                  </div>



                  {parkingProviders == 'PARK_PLUS' && (
                  <div class="col-md-8">
                    <div class="PageHead_Optons_Row">
                      <ul className='PageHead_Optons_RightAligned'>
                        <li>
                          <div className="SwInputWithIcon">
                            <SwInput
                             placeholder="Search..."
                             onKeyPress={filterListing}
                            />
                            <span className="SwInputicon">
                             <i className="bi bi-search"></i>
                            </span>
                            </div>
                        </li>
                        <li>
                          <ParkingReqFilterNew
                            clearSearch={''}
                            sendFilterToParent={childCallback}
                          />
                        </li>
                        <li>
                          <ParkingReqSortNew
                            parkingInfo={ParkingUser}
                            sendSortToParent={childCallback}
                          />
                        </li>

                     
                          <>
                            <li>
                              {alertMsg !== 400 ? (
                                <SwButton
                                size='sm'
                                variant='dark'
                                  type="button"
                                  onClick={openUrlInNewTab1}
                                >
                                  <i className="bi bi-upload pe-2" />
                                  Manage Tag Inventory
                                </SwButton>
                              ) : (
                                <SwButton
                                size='sm'
                                variant='dark'
                                  type="button"
                                  onClick={() => setIsAccessDeniedOpen(true)}
                                >
                                  <i className="bi bi-upload pe-2" />
                                  Manage Tag Inventory
                                </SwButton>
                              )}
                            </li>

                            <li>
                              {alertMsg !== 400 ? (
                                <SwButton
                                size='sm'
                                variant='dark'
                                  type="button"
                                  onClick={openUrlInNewTab}
                                >
                                  <span>
                                   <i className="bi bi-upload pe-2" />
                                  </span>
                                  Bulk Upload Vehicles
                                </SwButton>
                              ) : (
                                <SwButton
                                size='sm'
                                variant='dark'
                                  type="button"
                                   onClick={() => setIsAccessDeniedOpen(true)}
                                >
                                  <span>
                                    <i className="bi bi-upload pe-2" />
                                  </span>
                                  Bulk Upload Vehicles
                                </SwButton>
                              )}
                            </li>
                          </>
                      </ul>
                    </div>
                  </div>
                  )}
                </div>


              <div className="row align-items-end justify-content-between">
                {parkingProviders == 'PARK_PLUS' && (
                  <div className="col-md-12 SwTextSmall mb-3">
                    <div className=" d-inline-flex">
                      <i class="bi bi-info-circle-fill" />
                      <span className='ms-1'>
                        Read about{' '}
                        <a
                        className='SwLinkInfo HoverUnderline'
                          onClick={openModal}
                        >
                          tag issuance here
                        </a>{' '}
                        & check our{' '}
                        <a
                          href="https://d2jovvsod2x1gg.cloudfront.net/csp-files/Revised+-+Parking+Management+Guide.pdf"
                          target="_blank"
                          className='SwLinkInfo HoverUnderline'
                        >
                          detailed guide
                        </a>{' '}
                        for further information or steps.
                      </span>
                    </div>
                    <br />
                    <div className="d-inline-flex mt-1">
                      <i class="bi bi-info-circle-fill SwTextSmall" />
                      <span className='ms-1'>
                        If a vehicle is already whitelisted, please do not try to whitelist again.
                      </span>
                    </div>
                  </div>
                )}

                <div className="col-lg-3">
                    <label className='SwFormLabel'>Location</label>
                    <SwSelect
                    placeholder="Select Location"
                    options={LocationData}
                    value={selectedLocation}
                    onChange={onLocationChange}
                    isClearable={false}
                    />
                </div>

                <div className="col-md-8" />
              </div> 



                {selectedLocations.length > 0 ? (
                  <div class="row">
                    <div class="col-12">
                      {console.log("revfdsesdfc",bg)}
                      <SwKpiGroup>
          <SwKpi
          label="Total Request"
          value={ParkingCount?.total || 0}
          active={bg === 9}
          onClick={() => changeListStatus(9)}
        />

        <SwKpi
          label="Pending Actions"
          value={ParkingCount?.pending || 0}
          active={bg === 1}
          onClick={() => changeListStatus(1)}
        />
         <SwKpi
          label="Whitelisted"
          value={ParkingCount?.approved || 0}
          active={bg === 3}
          onClick={() => changeListStatus(3)}
        />

        <SwKpi
          label="Rejected"
          value={ParkingCount?.rejected || 0}
          active={bg === 6}
          onClick={() => changeListStatus(6)}
        />

        <SwKpi
          label="Deleted"
          value={ParkingCount?.deleted || 0}
          active={bg === 4}
          onClick={() => changeListStatus(4)}
        />
                      </SwKpiGroup>
                    </div>
                  </div>
                ) : (
                  ''
                )}
                
                <div class="row mb-5">
                  <div class="col-12">
                    {ParkingUser.length > 0 && selectedLocations.length !== 0 ? (
                      <AntDTable
                        rowKey="rec_id"
                        columns={columns}
                        dataSource={ParkingUser || []}
                        loading={false}
                        pagination
                        pageSize={article.limit}
                        currentPage={Math.floor(article.offset / article.limit) + 1}
                        totalRecords={totalRec}
                        onPageChange={(page, pageSize) => {
                          const newOffset = (page - 1) * pageSize;
                          article.offset = newOffset;
                          article.limit = pageSize;
                          previousPage(newOffset);
                        }}
                      />
                    
                ) : (
                  <div className='my-4'><SwNoData message="No Data available" />    </div>
                )}
                  </div>
                </div>


                <div className="ParkPlusFooter">
                  <div className="ParkPlusFooter-text">
                    <span>*</span>Must read: Please review our detailed parking
                    guide now!
                  </div>
                  <SwButton
                  size='sm'
                  className='ms-2'
                    href="https://d2jovvsod2x1gg.cloudfront.net/csp-files/Revised+-+Parking+Management+Guide.pdf"
                    target="_blank"
                  >
                    <span>View Guide</span>
                  </SwButton>
                </div>
              </div>
          <SwModal
  show={isModalOpen}
  onClose={closeModal}
  title="Tag Issuance Guidelines"
  centered
  backdrop="static"
  keyboard={false}
  className="TagIssuancePopup"
  footer={
    <div className="d-flex justify-content-center align-items-center gap-3">
      <SwButton
        size="sm"
        variant="dark-outline"
        onClick={closeModal}
      >
        Cancel
      </SwButton>

      <SwButton
        size="sm"
        as="a"
        href="https://d2jovvsod2x1gg.cloudfront.net/csp-files/Revised+-+Parking+Management+Guide.pdf"
        target="_blank"
      >
        <img src={ViewGuideicon} alt="Guide" className="me-2" />
        View Guide
      </SwButton>
    </div>
  }
>

  <p>
    1) For Cars: Fastag is mandatory, and no physical tags will be issued.
    Virtual Tags are mapped to the Fastag, allowing for the whitelisting of
    any number of cars at no cost. If you run out of Virtual Tags, please
    contact the Account Management Team.
  </p>

  <p>
    2) For Bikes: Physical RFID tags will be issued based on the number of
    bikes in the agreement or the number of cars converted into bikes.
    For example, if 1 car can be converted into 4 bikes, then 4 Physical
    Tags will be issued free of charge. Any additional Physical Tags shall
    be chargeable at Rs 100 plus taxes per tag.
  </p>

  <p>
    Note: If an employee leaves your company, it is the responsibility of
    the client to retrieve the tags and reissue them to the new employee.
    If Smartworks needs to issue a new Physical Tag or replace lost or
    damaged tags, the cost will be Rs 100 per tag per vehicle.
  </p>
</SwModal>

           <SwModal
  show={isActionModalOpen}
  onClose={() => setIsActionModalOpen(false)}
  backdrop="static"
  className='sw-small-modal'
  keyboard={false}
  footer={
    <div className="d-flex justify-content-center align-items-center gap-3">
      <SwButton
        size="sm"
        variant="dark-outline"
        onClick={() => setIsActionModalOpen(false)}
      >
        No
      </SwButton>

      <SwButton
        size="sm"
        variant="danger"
        onClick={() => {
          changeStatus(RequestId, RequestStatus, TagId);
          setIsActionModalOpen(false);
        }}
      >
        Yes
      </SwButton>
    </div>
  }
>

  <SwButton variant="" className='btn-close btn-close-custom' onClick={() => setIsActionModalOpen(false)}></SwButton>
  <div className='text-center'>
    <h3 className='SwModalSubHeading'>Parking Request</h3>
    <p>{RequestText}</p>
  </div>
</SwModal>

             <SwModal
  show={isDeleteModalOpen}
  onClose={() => setIsDeleteModalOpen(false)}
  backdrop="static"
  className='sw-small-modal'
  keyboard={false}
  footer={
    <div className="d-flex justify-content-center align-items-center gap-3">
      <SwButton
        size="sm"
        variant="dark-outline"
        onClick={() => setIsDeleteModalOpen(false)}
      >
        No
      </SwButton>

      <SwButton
        size="sm"
        variant="danger"
        onClick={() => {
          changeDeleteStatus(RequestId, VehicleNumber);
          setIsDeleteModalOpen(false);
        }}
      >
        Yes
      </SwButton>
    </div>
  }
>
  <SwButton variant="" className='btn-close btn-close-custom' onClick={() => setIsDeleteModalOpen(false)}></SwButton>
  <div className='text-center'>
    <h3 className='SwModalSubHeading'>Parking Request</h3>
    <p>{RequestText}</p>
  </div>
</SwModal>

         <SwModal
          show={isAccessDeniedOpen}
          onClose={() => setIsAccessDeniedOpen(false)}
          title=""
          backdrop="static"
          keyboard={false}
          className="sw-small-modal"
          footer={
            <div className="d-flex justify-content-center align-item-center">
              <SwButton
                size="sm"
                variant="dark"
                onClick={() => setIsAccessDeniedOpen(false)}
              >
                Close
              </SwButton>
            </div>
          }
        >
          <SwButton variant="" className='btn-close btn-close-custom' onClick={() => setIsAccessDeniedOpen(false)}></SwButton>
          
          <div className="text-center my-3">
            <div className="mb-3">
              <img src="img/access-warning-icon.svg" alt="Access Warning" width={100} />
              <h3 className="mt-3">Access Restricted</h3>
            </div>

            <p>
              Access to the ParkPlus dashboard is restricted.
              Kindly reach out to your account manager for
              additional details and assistance.
            </p>
          </div>
        </SwModal>
            </>
          ) : loaderServiceAccess == true ? (
            <>
              <SwLoader />
            </>
          ) : (
            <MarketingPanel />
          )}
        </Layout>
      </Layout>
    </>
  );
}
